const env = () => process.env.NODE_ENV;

const get = (key) => process.env[`REACT_APP_${key}`];

// eslint-disable-next-line import/no-anonymous-default-export -- Reason: legacy suppression retained until the owning code is migrated or cleaned up.
export default {
    env,
    get
};
